<template>
  <div class="BookFlight container_w dis_bo">
      <bread-crumb :crumbList="crumbList"></bread-crumb>
      <page-header :headerTitle="headerTitle"></page-header>
      <nav-book></nav-book>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader/PageHeader";
import NavBook from "@/components/HomeComponents/HomeNav/NavBook";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb";
export default {
  components: {
    PageHeader,
    NavBook,
    BreadCrumb
  },
  name: "BookFlight",
  data() {
    return {
      headerTitle:'Book a Flight',
      crumbList:[
          {
            name:'Book a Flight',
            url:''
          }
      ],
    };
  },
  props: {},
  watch: {},
  methods: {},
  filters: {},
  computed: {},
  created() {
    
  },
  mounted() {},
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
  // .BookFlight{
    
  // }

</style>
